var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLandArea = function SvgLandArea(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1.1rem",
    height: "1.1rem",
    viewBox: "0 0 22 22"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M2.357 0a.55.55 0 0 1 .55.55v1.257h16.284a.55.55 0 0 1 .365-.229l1.18-1.18a.55.55 0 0 1 .778.778L20.422 2.27a.554.554 0 0 1-.23.54v16.283h1.258a.55.55 0 0 1 0 1.1h-1.258v1.258a.55.55 0 1 1-1.1 0v-1.258H2.809a.55.55 0 0 1-.94-.06l-.072-.045a.55.55 0 0 1 .01-.896V2.907H.55a.55.55 0 0 1 0-1.1h1.257V.55a.55.55 0 0 1 .55-.55zm16.735 3.597L3.597 19.092h15.495V3.597zm-.866-.69H2.907v15.319L18.226 2.907z"
  })));
};
export default SvgLandArea;